export default "__VITE_ASSET__Dx5NkLhQ__"